import { WIDGET } from "@model/components/componentMeta.model";
const createWidgetImage = (options = {}) => {
  const { shape = 'square' } = options
  const randomkey = `${WIDGET.prefixKey}${Math.random().toString(36).substring(4)}`
  const key = `${WIDGET.prefixKey}${randomkey.substring(randomkey.length - 4, randomkey.length)}`
  return {
    key,
    object: {
      [key]: {
        data: {
          imageType: 'website',
          imageID: null,
          imageUrl: null,
          imageName: null,
          imageTitle: null,
          imageAlt: null,
          imageWidth: null,
          imageHeight: null,
        },
        id: key,
        properties: {
          isSystem: true,
          isEnableLink: false,
          link: {
            type: "url",
            url: null,
            pageID: null,
            target: "_self"
          }
        },
        style: {
          width: 200,
          height: 200,
          alignX: "center",
          shape,
          scaleType: "fill",
          opacity: 100,

          marginTop: 0,
          marginBottom: 0,

          // new attr
          cropZoomPct: 100,
          cropPosX: 0,
          cropPosY: 0,
          cropWidth: 0,
          cropHeight: 0,
          // override with new image
          resizePosX: 0,
          resizePosY: 0,
        },
        styleMobile: {
          marginTop: 0,
          marginBottom: 0
        },
        type: `SYSTEM_WIDGET_IMAGE`,
      }
    }
  }
}

export {
  createWidgetImage
}
export default {
  createWidgetImage
}